import './index.scss'
import {
  ProgressIndicator,
  Tooltip,
  ProgressStep
} from 'carbon-components-react'
ProgressIndicator.Step = ProgressStep
ProgressIndicator.Tooltip = Tooltip
export {
  ProgressIndicator,
  ProgressStep,
  Tooltip,
  ProgressIndicator as default
}
